export default __webpack_public_path__ + "static/media/current.6e722c42.png";